// import { canUseDOM } from 'exenv';

export function authorPageLoading(resp = {}, store = {}) {
  return {
    type: 'AUTHOR_PAGE_LOADING',
    authorPage: resp,
    store
  };
}

export function authorPageLoaded(resp = {}, store = {}) {
  return {
    type: 'AUTHOR_PAGE_LOADED',
    authorPage: resp,
    store
  };
}

export function authorPageLoadError(error, store = {}) {
  return {
    type: 'AUTHOR_PAGE_ERROR',
    authorPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
